import { render, staticRenderFns } from "./CompanyListScreen.vue?vue&type=template&id=7212b8ce&scoped=true&lang=pug"
import script from "./CompanyListScreen.vue?vue&type=script&lang=ts"
export * from "./CompanyListScreen.vue?vue&type=script&lang=ts"
import style0 from "./CompanyListScreen.vue?vue&type=style&index=0&id=7212b8ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7212b8ce",
  null
  
)

export default component.exports